export const bulkMapping = {
  "bulk_mapping_dialog.title": `Cargar Mapeos en Lote (CSV)`,
  "bulk_mapping_dialog.description": `Carga en lote todos tus mapeos según el formato proporcionado en el CSV de ejemplo`,
  "bulk_mapping_dialog.starting_execution_order": `Orden de Ejecución Inicial`,
  "bulk_mapping_dialog.execution_order_placeholder": `ej. 500`,
  "bulk_mapping_dialog.download_sample_csv": `Descargar sample.csv`,
  "bulk_mapping_dialog.upload_documents": `Sube tus Documentos`,
  "bulk_mapping_dialog.drag_and_drop": `Arrastra y suelta tus archivos aquí`,
  "bulk_mapping_dialog.browse_files": `Explorar Archivos`,
  "bulk_mapping_dialog.max_file_size": `Máximo un archivo CSV de 5MB`,
  "bulk_mapping_dialog.keep_previous_mapping": `Mantener Mapeos anteriores`,
  "bulk_mapping_dialog.upload_mapping": `Subir Mapeos`,
  "bulk_mapping_dialog.description_label": `Notas`,
  "bulk_mapping_dialog.description_placeholder": `ej. Mapeos de proveedores Q1`,
  "bulk_mapping_dialog.description_max_length": `Las notas no pueden exceder los 100 caracteres.`,
};
